import React, { useState, useEffect} from 'react';
import { BASE_API } from '../../../api/Globals';
import { helpHttp } from '../../../helpers/helpHttp';
import Menu from '../../../components/sturtural/Menu';
//import { useFormDemand } from '../../hooks/useFormDemand';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Navigate } from 'react-router-dom';
import Loader from '../../../components/sturtural/Loader';
import TawkMessengerReact from '../../../components/sturtural/Tawk';
import { Dialog } from 'primereact/dialog';
import { storage } from '../../../helpers/storage';

const initialForm = {
    nombre: "",
    apellido1: "",
    apellido2: "",
    curp: "",
    fecha_nacimiento: "",
    genero: "",
    domicilio: "",
    municipio: "",
    colonia: "",
    codigo_postal: "",
    telefono: "",
    correo_electronico: "", 
    institucion: "",
    titulo: "",
    entidad: "",
    pais: "",
    nivel: "",
    recibo: ""
}

const Demand = () => {
    const [form, setForm] = useState(initialForm);
	const [errors, setErrors] = useState({});
	const [loading, setLoading] = useState(false);
	const [response, setResponse] = useState(false);
	const [result, setResult] = useState(null);
	const [redirect, setRedirect] = useState(false);

    const [countries, setCountries] = useState(null); 
    const [loadCountries, setLoadCountries] = useState(false);
    const [error, setError] = useState(null);

    const [states, setStates] = useState(null); 
    const [loadStates, setLoadStates] = useState(false);

    const [levels, setLevels] = useState(null); 
    const [loadLevels, setLoadLevels] = useState(false);

    const [institutions, setInstitutions] = useState(null); 
    const [loadInstitutions, setLoadInstitutions] = useState(false);

    const [career, setCareer] = useState(null); 
    const [loadcareer, setLoadCareer] = useState(false);
    
    const [pais, setPais] = useState(117);
    const [entidad, setEntidad] = useState(26);
    const [nivel, setNivel] = useState(null);

    const [aviso, setAviso] = useState(false);

    let url_countries = `${BASE_API}catalog/countries`;
    useEffect(() => {
        setLoadCountries(true);
        helpHttp().get(url_countries).then(res => {
            if(!res.err) {
                setCountries(res.records);
                setError(null);                                                                      
            } else {
                setCountries(null);
                setError(res);
            }
            setLoadCountries(false); 
        });
    }, [url_countries]);

    let url_states = `${BASE_API}catalog/states/117`;
    useEffect(() => {
        setLoadStates(true);
        helpHttp().get(url_states).then(res => {
            if(!res.err) {
                setStates(res.records);
                setError(null);
            } else {
                setStates(null);
                setError(res);
            }
            setLoadStates(false); 
            handleInit();
        });
    }, [url_states]);

    let url_levels = `${BASE_API}catalog/levels`;
    useEffect(() => {
        setLoadLevels(true);
        helpHttp().get(url_levels).then(res => {
            if(!res.err) {
                setLevels(res.levels);
                setError(null);
            } else {
                setLevels(null);
                setError(res);
            }
            setLoadLevels(false); 
            handleInit();
        });
    }, [url_levels]);


    const handleInit = () => {
        let pais = {code: 117, name: "MÉXICO"};
        let entidad = {code: 26, name: "SONORA"};

        const initialForm = {
            nombre: form.nombre,
            apellido1: form.apellido1,
            apellido2: form.apellido2,
            curp: form.curp,
            fecha_nacimiento: form.fecha_nacimiento,
            genero: form.genero,
            domicilio: form.domicilio,
            municipio: form.municipio,
            colonia: form.colonia,
            codigo_postal: form.codigo_postal,
            telefono: form.telefono,
            correo_electronico: form.correo_electronico, 
            institucion: form.institucion,
            titulo: form.titulo,
            entidad: entidad,
            pais: pais,
            nivel: form.nivel,
            recibo: form.recibo
        }

        setForm(initialForm);
    }

    const validationsFrom = (form) => {
        let errors = {};
        let regexName = /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü\s]+$/;
        //let regexEmail = /^(\w+[/./-]?){1,}@[a-z]+[/.]\w{2,}$/;
        let regexEmail = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
        //let regexComments = /^.{1,255}$/;
        let regexNumbers = /^([0-9])*$/;
        let regexCurp = /^[A-Z]{1}[AEIOUX]{1}[A-Z]{2}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[HM]{1}(AS|BC|BS|CC|CS|CH|CL|CM|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)[B-DF-HJ-NP-TV-Z]{3}[0-9A-Z]{1}[0-9]{1}$/;
        //let regexRfc = /^(([A-Z]|[a-z]|\s){1})(([A-Z]|[a-z]){3})([0-9]{6})((([A-Z]|[a-z]|[0-9]){3}))/;
        let regexDigitos = /^.{1,10}$/;
        //let regexFecha = /^(?:3[01]|[12][0-9]|0?[1-9])([/])(0?[1-9]|1[1-2])\1\d{4}$/;
        //let regexFecha = /^([0]?[1-9]|[1|2][0-9]|[3][0|1])[./-]([0]?[1-9]|[1][0-2])[./-]([0-9]{4}|[0-9]{2})$/;
        let regexFecha = /(0[1-9]|[12][0-9]|3[01])[/](0[1-9]|1[012])[/]\d{4}/;
        
        if(!form.recibo.trim()) {
            errors.recibo = "El Campo (Numero de recibo) es requerido";
        }
    
        if(!form.nombre.trim()) {
            errors.nombre = "El Campo (Nombre) es requerido";
        } else if(!regexName.test(form.nombre.trim())){
            errors.nombre = "El Campo (Nombre) sólo acepta letras y espacios en blanco";
        }
    
        if(!form.apellido1.trim()) {
            errors.apellido1 = "El Campo (Primer apellido) es requerido";
        } else if(!regexName.test(form.apellido1.trim())){
            errors.apellido1 = "El Campo (Primer apellido) sólo acepta letras y espacios en blanco";
        }
    
        if(!form.telefono.trim()) {
            errors.telefono = "El Campo (Teléfono) es requerido";
        } else if(!regexNumbers.test(form.telefono.trim())) {
            errors.telefono = "El Campo (Teléfono) acepta sólo números";
        } else if(!regexDigitos.test(form.telefono.trim())) {
            errors.telefono = "El Campo (Teléfono) acepta hasta 10 dígitos";
        }
    
        if(!form.correo_electronico.trim()) {
            errors.correo_electronico = "El Campo (Correo electrónico) es requerido";
        } else if(!regexEmail.test(form.correo_electronico.trim())){
            errors.correo_electronico = "El Campo (Correo electrónico) es incorrecto";
        }
    
        if(!form.curp.trim()) {
            errors.curp = "El Campo (CURP) es requerido";
        } else if(!regexCurp.test(form.curp.trim())){
            errors.curp = "El Campo (CURP) es incorrecto";
        }
    
        if(!form.entidad.code) {
            errors.entidad = "El Campo (Entidad) es requerido";
        }
        
        if(!form.pais.code) {
            errors.pais = "El Campo (País) es requerido";
        }
    
        if(!form.titulo.code) {
            errors.titulo = "El Campo (Título) es requerido";
        }
    
        if(!form.institucion.code) {
            errors.institucion = "El Campo (Institución) es requerido";
        }
    
        if(!form.fecha_nacimiento) {
            errors.fecha_nacimiento = "El Campo (Fecha de nacimiento) es requerido";
        } else if(!regexFecha.test(form.fecha_nacimiento)) {
            errors.fecha_nacimiento = "El Campo (Fecha de nacimiento) acepta formato dd/mm/yyyy";
        }
    
        if(!form.domicilio.trim()) {
            errors.domicilio = "El Campo (Domicilio) es requerido";
        }
    
        if(!form.colonia.trim()) {
            errors.colonia = "El Campo (Colonia) es requerido";
        }
    
        let cp = form.codigo_postal.trim();
        if(!form.codigo_postal.trim()) {
            errors.codigo_postal = "El Campo (Código postal) es requerido";
        } else if(!regexNumbers.test(form.codigo_postal.trim())) {
            errors.codigo_postal = "El Campo (Código postal) acepta sólo números";
        } else if(cp.length !== 5) {
            errors.codigo_postal = "El Campo (Código postal) acepta 5 dígito";
        }
    
        if(!form.genero.code) {
            errors.genero = "Selecciona un (Género)";
        }
    
        if(!form.nivel.code) {
            errors.nivel = "Selecciona un (Nivel)";
        }
    
        if(!form.municipio.code) {
            errors.municipio = "Selecciona un (Municipio)";
        }
    
        return errors;
    }

    const handleChange = (e) => {
		const { name, value } = e.target;
        const code = value.code;

        if(name === 'pais') {
            setPais(code);
            handleChangeStates(code);
            setInstitutions([]);
            setCareer([]);
        } 

        if(name === 'institucion') {
            handleChangeCareer(code);
        }
  
        if(name === 'nivel') {
            setNivel(code);
            handleChangeInstitution(code);
        }

        if(name === 'entidad') {
            setEntidad(code);
            setLevels(levels);
            setInstitutions([]);
            setCareer([]);
        }

		setForm({
			...form,
			[name]: value,
		});
	};

    const handleChangeStates = (code) => {
        if(code !==117){
            code = 0;
        }
        let url_states = `${BASE_API}catalog/states/${code}`;
        setLoadStates(true);
        helpHttp().get(url_states).then(res => {
            if(!res.err) {
                setStates(res.records);
                setError(null);
            } else {
                setStates(null);
                setError(res);
            }
            setLoadStates(false); 
        });
    }

    const handleChangeInstitution = (code) => {
        let url_institutions =  `${BASE_API}institutions/actives/${pais}/${entidad}/${code}`;
        setLoadInstitutions(true);
        helpHttp().get(url_institutions).then(res => {
            if(!res.err) {
                setInstitutions(res.institutions);
                //setError(null);    
                //handleInit();     
                let institution = res.institutions;
                if(institution.length == 0){
                    setAviso(true);
                }
            } else {
                setInstitutions(null);
                //setError(res);
            }
            setLoadInstitutions(false); 
        });
    }

    const handleChangeCareer = (code) => {
        let url_career =  `${BASE_API}institutions/career/${code}/${nivel}`;
        setLoadCareer(true);
        helpHttp().get(url_career).then(res => {
            if(!res.err) {
                setCareer(res.career);
                //setError(null);    
                //handleInit();                                                               
            } else {
                setCareer(null);
                //setError(res);
            }
            setLoadCareer(false); 
        });
    }

	const handleBlur = (e) => {
		handleChange(e);
		setErrors(validationsFrom(form));
	};

	const setDisplayBasic = () => {
        setResponse(false);
    }

    const setDisplayAviso = () => {
        setAviso(false);
    }

	const handleSubmit = (e) => {
		e.preventDefault();
		setErrors(validationsFrom(form));

		if (Object.keys(errors).length === 0) {
			let nombre = form.nombre.trim();
			let apellido1 = form.apellido1.trim();
			let apellido2 = form.apellido2.trim();

			let fecha_nacimiento = form.fecha_nacimiento;
            let arrFechaNacimiento = fecha_nacimiento.split('/');
            let _arrFechaNacimiento = arrFechaNacimiento[2] + '-' + arrFechaNacimiento[1] + '-' + arrFechaNacimiento[0];

			const arrUser = {
				nombre: nombre.toUpperCase(),
				apellido1: apellido1.toUpperCase(),
				apellido2: apellido2.toUpperCase(),
				curp: form.curp.trim(),
				fecha_nacimiento: _arrFechaNacimiento,
				genero: form.genero.code,
				domicilio: form.domicilio.trim(),
				municipio: form.municipio.code,
				colonia: form.colonia.trim(),
				codigo_postal: form.codigo_postal.trim(),
				telefono: form.telefono.trim(),
				correo_electronico: form.correo_electronico.trim(),
				institucion: form.institucion.code,
				titulo: form.titulo.code,
				entidad: form.entidad.code,
				pais: form.pais.code,
				nivel: form.nivel.code,
				recibo: form.recibo.trim(),
				usuarioid: storage.get('id'),
				statusid: 3
			};

			setLoading(true);

			helpHttp().post(`${BASE_API}demand/add`, {
				body: arrUser,
				headers: {
					"Content-Type": "application/json; charset=utf-8",
					"Accept": "application/json",
					'Access-Control-Allow-Origin': '*',
					'x-access-token': storage.get('token')
				},
			}).then((res) => {
				setLoading(false);
				if(res.response === 'off') {
					setResult(res.message);
				} else if(res.response === 'on') {
					setResult(res.message);
					setForm(initialForm);
					setTimeout(() => setRedirect(true), 5000);
				} else {
					setResult("(41) Ocurrió un error al intentar realizar este proceso, favor de comunicarse con el administrador del sistema.");
				}
				setResponse(true);
			});
		} else {
			return;
		}
	};

    const dropdownItemsMunicipios = [
        {
            code : 1,
            name : "ACONCHI",
        },
        {
            code : 2,
            name : "AGUA PRIETA",

        },
        {
            code : 3,
            name : "ALAMOS",
        },
        {
            code : 4,
            name : "ALTAR",
        },
        {
            code : 5,
            name : "ARIVECHI",
        },
        {
            code : 6,
            name : "ARIZPE",
        },
        {
            code : 7,
            name : "ATIL",
        },
        {
            code : 8,
            name : "BACADEHUACHI",
        },
        {
            code : 9,
            name : "BACANORA",
        },
        {
            code : 10,
            name : "BACERAC",
        },
        {
            code : 11,
            name : "BACOACHI",
        },
        {
            code : 12,
            name : "BACUM",
        },
        {
            code : 13,
            name : "BANAMICHI",
        },
        {
            code : 14,
            name : "BAVIACORA",
        },
        {
            code : 15,
            name : "BAVISPE",
        },
        {
            code : 16,
            name : "BENJAMIN HILL",
        },
        {
            code : 17,
            name : "CABORCA",
        },
        {
            code : 18,
            name : "CAJEME",
        },
        {
            code : 19,
            name : "CANANEA",
        },
        {
            code : 20,
            name : "CARBO",
        },
        {
            code : 21,
            name : "COLORADA, LA",
        },
        {
            code : 22,
            name : "CUCURPE",
        },
        {
            code : 23,
            name : "CUMPAS",
        },
        {
            code : 24,
            name : "DIVISADEROS",
        },
        {
            code : 25,
            "mun_inegiid" : "025",
            name : "EMPALME",
        },
        {
            code : 26,
            name : "ETCHOJOA",
        },
        {
            code : 27,
            name : "FRONTERAS",
        },
        {
            code : 28,
            name : "GRANADOS",
        },
        {
            code : 29,
            name : "GUAYMAS",
        },
        {
            code : 30,
            name : "HERMOSILLO",
        },
        {
            code : 31,
            name : "HUACHINERA",
        },
        {
            code : 32,
            name : "HUASABAS",
        },
        {
            code : 33,
            name : "HUATABAMPO",
        },
        {
            code : 34,
            name : "HUEPAC",
        },
        {
            code : 35,
            name : "IMURIS",
        },
        {
            code : 36,
            name : "MAGDALENA",
        },
        {
            code : 37,
            name : "MAZATAN",
        },
        {
            code : 38,
            name : "MOCTEZUMA",
        },
        {
            code : 39,
            name : "NACO",
        },
        {
            code : 40,
            name : "NACORI CHICO",
        },
        {
            code : 41,
            name : "NACOZARI DE GARCIA",
        },
        {
            code : 42,
            name : "NAVOJOA",
        },
        {
            code : 43,
            name : "NOGALES",
        },
        {
            code : 44,
            name : "ONAVAS",
        },
        {
            code : 45,
            name : "OPODEPE",
        },
        {
            code : 46,
            name : "OQUITOA",
        },
        {
            code : 47,
            name : "PITIQUITO",
        },
        {
            code : 48,
            name : "PUERTO PEÑASCO",
        },
        {
            code : 49,
            name : "QUIRIEGO",
        },
        {
            code : 50,
            name : "RAYON",
        },
        {
            code : 51,
            name : "ROSARIO",
        },
        {
            code : 52,
            name : "SAHUARIPA",
        },
        {
            code : 53,
            name : "SAN FELIPE DE JESUS",
        },
        {
            code : 54,
            name : "SAN JAVIER",
        },
        {
            code : 55,
            name : "SAN LUIS RIO COLORADO",
        },
        {
            code : 56,
            name : "SAN MIGUEL DE HORCASITAS",
        },
        {
            code : 57,
            name : "SAN PEDRO DE LA CUEVA",
        },
        {
            code : 58,
            name : "SANTA ANA",
        },
        {
            code : 59,
            name : "SANTA CRUZ",
        },
        {
            code : 60,
            name : "SARIC",
        },
        {
            code : 61,
            name : "SOYOPA",
        },
        {
            code : 62,
            name : "SUAQUI GRANDE",
        },
        {
            code : 63,
            name : "TEPACHE",
        },
        {
            code : 64,
            name : "TRINCHERAS",
        },
        {
            code : 65,
            name : "TUBUTAMA",
        },
        {
            code : 66,
            name : "URES",
        },
        {
            code : 67,
            name : "VILLA HIDALGO",
        },
        {
            code : 68,
            name : "VILLA PESQUEIRA",
        },
        {
            code : 69,
            name : "YECORA",
        },
        {
            code : 70,
            name : "GENERAL PLUTARCO ELIAS CALLES",
        },
        {
            code : 71,
            name : "BENITO JUAREZ",
        },
        {
            code : 72,
            name : "SAN IGNACIO RIO MUERTO",
        }
    ];

    const dropdownItemsGenero = [
        {name: 'Hombre', code: "H"},
        {name: 'Mujer', code: "M"}
    ];

    const basicDialogFooter = <Button type="button" label="Aceptar" onClick={() => setDisplayBasic(false)} icon="pi pi-check" className="p-button-secondary" />;

    return (
        <>
            {redirect && <Navigate to={'/lista-solicitudes'} />}

            <Menu link='nueva-solicitud' />
            
            <div className="grid">
                <form onSubmit={handleSubmit} className="col-12">
                    <div className="card">
                        <h3>Registro de solicitud de cédula profesional</h3>
                        <h5>Datos personales</h5>
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-4">
                                <label htmlFor="nombre">Nombre:</label>
                                <InputText id="nombre" name="nombre" type="text" value={form.nombre.toUpperCase()} onChange={handleChange} onBlur={handleBlur} className={errors.nombre && 'p-invalid'} autoFocus  />
                                {errors.nombre && <small className="p-error">{errors.nombre}</small>}
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="apellido1">Primer apellido:</label>
                                <InputText id="apellido1" name="apellido1" type="text" value={form.apellido1.toUpperCase()} onChange={handleChange} onBlur={handleBlur} className={errors.apellido1 && 'p-invalid'} />
                                {errors.apellido1 && <small className="p-error">{errors.apellido1}</small>}
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="apellido2">Segundo apellido:</label>
                                <InputText id="apellido2" name="apellido2" type="text" value={form.apellido2.toUpperCase()} onChange={handleChange} />
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="curp">CURP:</label>
                                <InputText id="curp" name="curp" type="text" value={form.curp.toUpperCase()} onChange={handleChange} onBlur={handleBlur} className={errors.curp && 'p-invalid'}  />
                                {errors.curp && <small className="p-error">{errors.curp}</small>}
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="fecha_nacimiento">Fecha de nacimiento: Ejemplo: 07/02/1943</label>
                                {/* <Calendar dateFormat="yy-mm-dd" id="fecha_nacimiento" name="fecha_nacimiento" value={form.fecha_nacimiento} onChange={handleChange} onBlur={handleBlur} className={errors.fecha_nacimiento && 'p-invalid'} defaultDate={form.fecha_nacimiento} showIcon showButtonBar monthNavigator yearNavigator yearRange="1920:2022"></Calendar> */}
                                <span className="p-input-icon-right">
                                    <InputText type="text" id="fecha_nacimiento" name="fecha_nacimiento" placeholder="dd/mm/yyyy" value={form.fecha_nacimiento} onChange={handleChange} onBlur={handleBlur} className={errors.fecha_nacimiento && 'p-invalid'} />
                                    <i className="pi pi-calendar" />
                                </span>
                                {errors.fecha_nacimiento && <small className="p-error">{errors.fecha_nacimiento}</small>}
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="genero">Género:</label>
                                <Dropdown id="genero" name="genero" value={form.genero} options={dropdownItemsGenero} optionLabel="name" placeholder="Elige tu género" onChange={handleChange} onBlur={handleBlur} className={errors.genero && 'p-invalid'}></Dropdown>
                                {errors.genero && <small className="p-error">{errors.genero}</small>}
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="domicilio">Domicilio particular:</label>
                                <InputText id="domicilio" name="domicilio" type="text" value={form.domicilio.toUpperCase()} onChange={handleChange} onBlur={handleBlur} className={errors.domicilio && 'p-invalid'}  />
                                {errors.domicilio && <small className="p-error">{errors.domicilio}</small>}
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="colonia">Colonia:</label>
                                <InputText id="colonia" name="colonia" type="text" value={form.colonia.toUpperCase()} onChange={handleChange} onBlur={handleBlur} className={errors.colonia && 'p-invalid'} />
                                {errors.colonia && <small className="p-error">{errors.colonia}</small>}
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="codigo_postal">Código postal:</label>
                                <InputText id="codigo_postal" name="codigo_postal" type="text" value={form.codigo_postal} onChange={handleChange} onBlur={handleBlur} className={errors.codigo_postal && 'p-invalid'} />
                                {errors.codigo_postal && <small className="p-error">{errors.codigo_postal}</small>}
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="municipio">Municipio:</label>
                                <Dropdown id="municipio" name="municipio" value={form.municipio}  options={dropdownItemsMunicipios} optionLabel="name" placeholder="Elige un municipio" onChange={handleChange} onBlur={handleBlur} className={errors.municipio && 'p-invalid'}></Dropdown>
                                {errors.municipio && <small className="p-error">{errors.municipio}</small>}
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="correo_electronico">Correo electrónico:</label>
                                <InputText id="correo_electronico" name="correo_electronico" type="text" value={form.correo_electronico.toLowerCase()} onChange={handleChange} onBlur={handleBlur} className={errors.correo_electronico && 'p-invalid'} />
                                {errors.correo_electronico && <small className="p-error">{errors.correo_electronico}</small>}
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="telefono">Teléfono:</label>
                                <InputText id="telefono" name="telefono" type="text" value={form.telefono} onChange={handleChange} onBlur={handleBlur} className={errors.telefono && 'p-invalid'} />
                                {errors.telefono && <small className="p-error">{errors.telefono}</small>}
                            </div>
                        </div>
                    </div>

                    <div className="card">
                        <h5>Estudios profesionales</h5>
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-6">
                                <label htmlFor="pais">{loadCountries && <i className="pi pi-spin pi-spinner" style={{ fontSize: '1rem' }}></i>} País:</label>
                                <Dropdown id="pais" name="pais" value={form.pais} options={countries} optionLabel="name" placeholder="Elige el país" onChange={handleChange} onBlur={handleBlur} className={errors.pais && 'p-invalid'}></Dropdown>
                                {errors.pais && <small className="p-error">{errors.pais}</small>}
                            </div>

                            <div className="field col-12 md:col-6">
                                <label htmlFor="entidad">{loadStates && <i className="pi pi-spin pi-spinner" style={{ fontSize: '1rem' }}></i>} Entidad:</label>
                                <Dropdown id="entidad" name="entidad" value={form.entidad} options={states} optionLabel="name" placeholder="Elige la entidad federativa (Estado)" onChange={handleChange} onBlur={handleBlur} className={errors.entidad && 'p-invalid'}></Dropdown>
                                {errors.entidad && <small className="p-error">{errors.entidad}</small>}
                            </div>
            
                            <div className="field col-12 md:col-6">
                                <label htmlFor="nivel">{loadLevels && <i className="pi pi-spin pi-spinner" style={{ fontSize: '1rem' }}></i>} Nivel:</label>
                                <Dropdown id="nivel" name="nivel" value={form.nivel}  options={levels} optionLabel="name" placeholder="Elige un nivel" onChange={handleChange} onBlur={handleBlur} className={errors.nivel && 'p-invalid'}></Dropdown>
                                {errors.nivel && <small className="p-error">{errors.nivel}</small>}
                            </div>

                            <div className="field col-12 md:col-6">
                                <label htmlFor="institucion">{loadInstitutions && <i className="pi pi-spin pi-spinner" style={{ fontSize: '1rem' }}></i>}  Nombre de la institución educativa:</label>
                                <Dropdown id="institucion" name="institucion" value={form.institucion} options={institutions} optionLabel="name" placeholder="Elige una institución" onChange={handleChange} onBlur={handleBlur} className={errors.institucion && 'p-invalid'}></Dropdown>
                                {errors.institucion && <small className="p-error">{errors.institucion}</small>}
                            </div>

                            <div className="field col-12 md:col-6">
                                <label htmlFor="titulo">{loadcareer && <i className="pi pi-spin pi-spinner" style={{ fontSize: '1rem' }}></i>}Título (Plan de estudios o carrera):</label>
                                <Dropdown id="titulo" name="titulo" value={form.titulo} options={career} optionLabel="name" placeholder="Elige un título de carrera" onChange={handleChange} onBlur={handleBlur} className={errors.titulo && 'p-invalid'}></Dropdown>
                                {errors.titulo && <small className="p-error">{errors.titulo}</small>}
                            </div>

                            <div className="field col-12 md:col-6">
                                <label htmlFor="recibo"><strong>Número de recibo de pago ante Hacienda:</strong></label>
                                <InputText id="recibo" name="recibo" type="text" value={form.recibo} onChange={handleChange} onBlur={handleBlur} className={errors.entidad && 'p-invalid'} />
                                <p><small className="p-invalid"></small></p>
                                {errors.recibo && <small className="p-error">{errors.recibo}</small>}
                            </div>
                        </div>
                    </div>

                    <div className="card">
                        {loading && <div><Loader /></div>}
                        <Button type="submit" value="Enviar" label="Guardar y continuar" className="mr-2 mb-2"></Button>
                    </div>     
                </form>
            </div>

            <Dialog header="Aviso" visible={response} style={{ width: '30vw' }} modal footer={basicDialogFooter} onHide={() => setDisplayBasic(false)}>
                <p>{result && result}</p>
            </Dialog>

            <Dialog header="Aviso" visible={aviso} style={{ width: '30vw' }} modal onHide={() => setDisplayAviso(false)}>
            <span>Este país no cuenta con ninguna institución registrada en el sistema. Para realizar este paso, favor de solicitar la alta a la Dirección de Registro y Servicio a Profesionistas por cualquiera de los siguientes medios:</span><br /><br />
            1.	Correo electrónico al cedula.profesional@sonora.edu.mx<br /> 
            2.	Por el chat del sistema.<br /><br />
            En los dos casos, debe solicitar la alta de la institución en la que realizó sus estudios y adjuntar copia de su comprobante de estudios que contenga el nombre completo de la institución y el nombre de su carrera o programa de estudios.
            </Dialog>

            <TawkMessengerReact />
        </>
    )
}

export default Demand;